var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch(e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " + extraClasses + "'></div>");
	}
}

site.frontpage = {
	init: function() {
		site.frontpage.animation();
		if ($('.contactBox').length > 0 && $('form.contactForm').length > 0) {
			site.frontpage.frontForm();
		}

		site.owl.init('#owl-hero', {
			loop:true,
			dots:true,
			items:1,
			autoplay: false,
			autoHeight: true,
			autoplayTimeout: 8000,
			autoplayHoverPause: true,
			smartSpeed: 1000,
			onChanged: site.frontpage.owlChanged,
		});
	},
	animation: function() {
		var $advertBoxImg = $('.frontpage-wrap .box #front-promo ul li .wrap .image');
		var $advertBoxCont = $('.frontpage-wrap .box #front-promo ul li .wrap .content');
		$advertBoxImg.css('opacity', 0).addClass('animated');
		$advertBoxCont.css('opacity', 0).addClass('animated');

		$advertBoxImg.waypoint(function() {
			$(this.element).removeAttr('style');
			$(this.element).addClass("fadeInRight");
		}, {offset: '80%'});

		$advertBoxCont.waypoint(function() {
			$(this.element).removeAttr('style');
			$(this.element).addClass("fadeInLeft");
		}, {offset: '80%'});
	},
	frontForm: function() {
		$('.contactBox a').on('click', function() {
			var form = $('.box_formbuilder.contact');
			if ($(this).hasClass('formOpen')) {
				form.css('max-height', 0);
				form.css('opacity', 0);
				form.css('visibility', 'hidden');
				$(this).removeClass('formOpen');
			} else {
				site.maxHeight.setHeight('.box_formbuilder.contact');
				$(this).addClass('formOpen');
				form.css('opacity', 1);
				form.css('visibility', 'visible');
			}
		});
	},
	owlChanged: function() {
		const yt = document.getElementById('player');
		if (yt) {
			yt.contentWindow.postMessage(JSON.stringify({
				'event': 'command',
				'func': 'pauseVideo',
				'args': []
			}), '*');
		}
	}
}

site.promoLogos = {
	init: function() {
		var $frontOwlSelector = '.promoLogos ul';
		var $frontOwlSettings = {
			items: 3,
			nav: false,
			autoHeight: true,
			dots: false,
		};
		if($($frontOwlSelector).length === 0) {
			return;
		}
		if ($(window).width() < 768) {
			site.owl.init($frontOwlSelector, $frontOwlSettings);
		}
		$(window).resize(function() {
			if ($(window).width() < 768) {
				site.owl.init($frontOwlSelector, $frontOwlSettings);
			} else {
				$($frontOwlSelector).trigger('destroy.owl.carousel');
			}
		});
	}
}

site.labelFocus = {
	init: function() {
		if ($('body').is('admin')) return false;

		var $form = $('form');
		if ($form.length) {
			$form.find('input[type="text"], textarea').focus(function() {
				$(this).parents('.elm').addClass('focus');
			}).blur(function() {
				if ($(this).val() === '') {
					$(this).parents('.elm').removeClass('focus');
				}
			}).each(function() {
				if ($(this).attr('value') !== '') {
					$(this).parents('.elm').addClass('focus');
				}
			});
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});
	var $body = $('body');
	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	$('#box_custom_7 label').inFieldLabels();

	site.owl.init('#courses .courseReviews ul', {
		items: 1,
		autoHeight: true,
		nav: true,
		mouseDrag: false,
		animateOut: 'fadeOut',
		animateIn: 'fadeIn'
	});

	if ($body.is('.frontpage')) {
		site.frontpage.init()
	}
	if ($('form.contactForm').length > 0) {
		site.labelFocus.init();
	}
	site.promoLogos.init();

	// Move Namsbrautir element to the top
	//$('body.coursesCategory .subCategory.filter-category-namsbrautir-1').insertAfter($('.courses__filter', '#courses'));
	//$('body.coursesCategory .subCategory.filter-category-namsbrautir-2').insertAfter($('.courses__filter', '#courses'));

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
